module.exports = __webpack_public_path__ + "img/IMAGE 2.7efe1b8b.png";